import { render, staticRenderFns } from "./PromoArea.vue?vue&type=template&id=7544dcc5&scoped=true&"
import script from "./PromoArea.vue?vue&type=script&lang=js&"
export * from "./PromoArea.vue?vue&type=script&lang=js&"
import style0 from "./PromoArea.vue?vue&type=style&index=0&id=7544dcc5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7544dcc5",
  null
  
)

export default component.exports